import request from '@/utils/request'

/**
 * 获取租户列表信息
 * @param data
 */
export function getCustomList (data) {
  return request({
    url: `/v1/tenants?limit=${data.limit}&page=${data.page}`,
    method: 'get'
  })
}

/**
 * 获取页面配置
 * @param data
 */
export function getPageSetting (data) {
  return request({
    url: `/v1/config/login/all?tenantCode=${data.tenantCode}`,
    method: 'get'
  })
}

/**
 * 获取资源设定
 * @param data
 */
export function getlinkSetting (data) {
  return request({
    url: '/v1/config/resources',
    method: 'post',
    data
  })
}
